import React, { Component } from 'react'
import PropTypes from 'prop-types'
import ConversationListItem from './ConversationListItem'

class ConversationsWrapper extends Component {
  static propTypes = {
    attachedMedia: PropTypes.string,
    previewPendingMedia: PropTypes.func.isRequired,
    conversationById: PropTypes.objectOf(
      PropTypes.shape({
        active: PropTypes.bool,
        created_at: PropTypes.string,
        id: PropTypes.number,
        patients: PropTypes.arrayOf(
          PropTypes.shape({
            first_name: PropTypes.string,
            last_name: PropTypes.string,
          }),
        ),
        seen: PropTypes.bool,
        subject: PropTypes.string,
        updated_at: PropTypes.string,
      }),
    ),
    countryCode: PropTypes.string,
    currentConversationId: PropTypes.number,
    handleChooseCurrentConversation: PropTypes.func.isRequired,
    handleMessageFocus: PropTypes.func.isRequired,
    hasRemindersTier2: PropTypes.bool.isRequired,
    isEmail: PropTypes.bool,
    patientConversations: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.number,
      }),
    ).isRequired,
    patientMessages: PropTypes.arrayOf(
      PropTypes.arrayOf(
        PropTypes.shape({
          id: PropTypes.number,
        }),
      ),
    ).isRequired,
    selectedMessageId: PropTypes.oneOfType([PropTypes.number, PropTypes.bool])
      .isRequired,
  }

  static defaultProps = {
    patientConversations: [],
    patientMessages: [],
  }

  selectNextConversation = (nextId) => {
    this.props.handleChooseCurrentConversation(nextId)
  }

  render() {
    const {
      attachedMedia,
      conversationById,
      countryCode,
      currentConversationId,
      hasRemindersTier2,
      isEmail,
      patientConversations,
      patientMessages,
      previewPendingMedia,
    } = this.props

    return (
      <div>
        {patientConversations.map((conversation, index) => (
          <ConversationListItem
            key={conversation.id}
            conversation={conversation}
            conversationById={conversationById}
            countryCode={countryCode}
            handleMessageFocus={this.props.handleMessageFocus}
            handleSelectConvo={this.selectNextConversation}
            hasRemindersTier2={hasRemindersTier2}
            isEmail={isEmail}
            isSelected={conversation.id === currentConversationId}
            messages={patientMessages[index]}
            selectedMessageId={this.props.selectedMessageId}
            attachedMedia={attachedMedia}
            previewPendingMedia={previewPendingMedia}
          />
        ))}
      </div>
    )
  }
}

export default ConversationsWrapper



// WEBPACK FOOTER //
// ./src/components/PatientPage/Messages/ConversationsWrapper.js